export enum OnboardingFlowStage {
  INITIAL = 'INITIAL',
  DATA_PROCESSING_IN_PROGRESS = 'DATA_PROCESSING_IN_PROGRESS',
  DATA_PROCESSING_COMPLETED = 'DATA_PROCESSING_COMPLETED',
}
